module.exports = __webpack_public_path__ + "static/media/payment-failed.2e8420d5.svg";